module.exports = __webpack_public_path__ + "img/kingfonguniversity.bb0be8c1.png";